import React from "react";
import Testimonials from "../../PicesForPages/FHA_family.png";
import ClientReview from "../Client_Review/clientReview";

function TestimonialsReview() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={Testimonials}
          alt="NewsPaperImage"
          className="background-video aboutUsImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Testimonials</span>
        </div>
      </div>
      <ClientReview />
    </div>
  );
}

export default TestimonialsReview;
